import { render, staticRenderFns } from "./Award.vue?vue&type=template&id=4ad99168&scoped=true&"
import script from "./Award.vue?vue&type=script&lang=js&"
export * from "./Award.vue?vue&type=script&lang=js&"
import style0 from "./Award.vue?vue&type=style&index=0&id=4ad99168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad99168",
  null
  
)

export default component.exports